// extracted by mini-css-extract-plugin
export default {"table":"profile_table__Q326m","th":"profile_th__PG1L+","td":"profile_td__vKHl5","tr":"profile_tr__zqN4l","checkbox":"profile_checkbox__KPkQs"};